import React, { useState } from 'react';
import { useQuery } from 'hooks/apollo';
import { gql } from '@apollo/client';

import { Input } from 'antd';
import Page from 'components/Page';
import Table from 'components/Table';

import { dayjs } from 'shared/utils/date';
import globalMessages from 'translations/messages';
import useFormatMessage from 'hooks/useFormatMessage';
import StatusTag from 'components/StatusTag';

const QUERY = gql`
  query {
    dataSourceLicenses {
      id
      title
      uniqueTitle
      startDate
      endDate
      renewalDate
      interval
      dataSource {
        id
        title
        customer {
          id
          name
        }
      }
      license {
        id
        title
        uniqueTitle
      }
      modules {
        id
        module
        title      
        uniqueTitle  
      }
    }
  }
`;

function getStatus(license) {
  if (license.endDate && dayjs(license.endDate).isBefore()) {
    return 'FINISHED';
  }

  if (dayjs(license.startDate).isAfter()) {
    return 'UPCOMING';
  }

  return 'ACTIVE';
}

const columns = [
  {
    dataIndex: ['dataSource', 'customer', 'name'],
    title: 'Account',
  },
  {
    dataIndex: ['dataSource', 'title'],
    title: 'Data source',
  },
  {
    dataIndex: 'title',
    title: 'License',
  },
  {
    dataIndex: 'startDate',
    title: 'Start Date',
    type: 'date',
  },
  {
    dataIndex: 'endDate',
    title: 'End Date',
    type: 'date',
  },
  {
    dataIndex: 'renewalDate',
    title: 'Renewal Date',
    type: 'date',
    defaultSortOrder: 'descend',
  },
  {
    dataIndex: 'status',
    title: 'Status',
    render: (_, record) => <StatusTag status={getStatus(record)} />,
  },
];

const DataSourceLicenses = () => {
  const $t = useFormatMessage();
  const { data, loading } = useQuery(QUERY);
  const [search, setSearch] = useState();

  return (
    <Page>
      <Page.Header
        title="Data Source Licenses"
      />
      <Page.Content>
        <Input.Search
          onSearch={setSearch}
          allowClear
          placeholder={$t(globalMessages.search)}
          style={{ marginBottom: '1em' }}
        />
        <Table
          loading={loading}
          columns={columns}
          dataSource={data?.dataSourceLicenses}
          search={search}
        />
      </Page.Content>
    </Page>
  );
};

export default DataSourceLicenses;
